const Home = (props) => {
  props.history.push("/products");
  return null;
};

export default Home;
